/**
 * Phone shop sheet: drill panels, swipe back, tap feedback, and prefetch.
 * Desktop menus do not use this file.
 *
 * Late menus (ri-header-menus.js): when the header ships without the sheet, this waits for
 * ri:header-menus and wires the sheet up once it is in the page.
 */
(function () {
  function boot() {
    var nav = document.querySelector('.ri-mnav');
    if (!nav || nav._riMnavBooted) return;
    nav._riMnavBooted = true;

    var details = document.getElementById('Details-menu-drawer-container');
    var stage = nav.querySelector('.ri-mnav__stage');
    var stack = [{ id: 'home', opener: null }];
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var busy = false;
    var scrollMemo = {};
    var prefetched = {};
    var SLIDE_MS = 280;

    function panelById(id) {
      return nav.querySelector('[data-ri-mnav-panel="' + id + '"]');
    }

    function panelId(panel) {
      return panel ? panel.getAttribute('data-ri-mnav-panel') : '';
    }

    function scrollerOf(panel) {
      return panel ? panel.querySelector('.ri-mnav__scroll') : null;
    }

    function ensureRails() {
      nav.querySelectorAll('.ri-mnav__scroll').forEach(function (scroller) {
        if (scroller._riRail) return;
        var rail = document.createElement('div');
        rail.className = 'ri-mnav__rail';
        rail.hidden = true;
        rail.setAttribute('aria-hidden', 'true');
        var thumb = document.createElement('span');
        thumb.className = 'ri-mnav__thumb';
        rail.appendChild(thumb);
        scroller.insertAdjacentElement('afterend', rail);
        scroller._riRail = rail;
      });
    }

    function paintRail(scroller) {
      if (!scroller) return;
      /* Rows fitted to the screen can land a pixel or two over it, which let the menu scroll a hair (owner,
         2026-10-23). That much is not worth a scroll. */
      var over = scroller.scrollHeight - scroller.clientHeight;
      var fit = scroller.clientHeight > 0 && over > 0 && over <= 2;
      scroller.classList.toggle('is-fit', fit);
      if (fit && scroller.scrollTop) scroller.scrollTop = 0;
      var rail = scroller._riRail;
      if (!rail) return;
      var panel = scroller.closest('.ri-mnav__panel');
      if (!panel || panel.hidden || !panel.classList.contains('is-active')) {
        rail.hidden = true;
        return;
      }
      var view = scroller.clientHeight;
      var max = scroller.scrollHeight - view;
      var overflow = view >= 48 && max > 2;
      if (scroller.classList.contains('is-overflow') !== overflow) {
        scroller.classList.toggle('is-overflow', overflow);
        view = scroller.clientHeight;
        max = scroller.scrollHeight - view;
        overflow = view >= 48 && max > 2;
        scroller.classList.toggle('is-overflow', overflow);
      }
      if (!overflow) {
        rail.hidden = true;
        return;
      }
      var inset = 8;
      var track = Math.max(24, view - inset * 2);
      rail.hidden = false;
      rail.style.top = scroller.offsetTop + inset + 'px';
      rail.style.height = track + 'px';
      var thumb = rail.firstElementChild;
      var thumbH = Math.max(36, Math.round((view / scroller.scrollHeight) * track));
      if (thumbH > track) thumbH = track;
      var travel = Math.max(0, track - thumbH);
      var y = (scroller.scrollTop / max) * travel;
      thumb.style.height = thumbH + 'px';
      thumb.style.transform = 'translateY(' + y + 'px)';
    }

    function paintRails() {
      ensureRails();
      nav.querySelectorAll('.ri-mnav__scroll').forEach(paintRail);
    }

    function activePanel() {
      return nav.querySelector('.ri-mnav__panel.is-active');
    }

    function focusEl(el) {
      if (!el || typeof el.focus !== 'function') return;
      try {
        el.focus({ preventScroll: true });
      } catch (error) {
        el.focus();
      }
    }

    function retrap(el) {
      if (!details || typeof trapFocus !== 'function') return;
      trapFocus(details, el || details.querySelector('summary'));
    }

    function clearInline(panel) {
      if (!panel) return;
      panel.style.transform = '';
      panel.style.visibility = '';
      panel.classList.remove('is-dragging');
    }

    function restoreScroll(panel) {
      var scroller = scrollerOf(panel);
      if (scroller) scroller.scrollTop = scrollMemo[panelId(panel)] || 0;
    }

    function revealCurrent(panel) {
      var scroller = scrollerOf(panel);
      if (!scroller) return;
      var current = scroller.querySelector('.ri-mnav__card.is-current, .ri-mnav__row.is-current');
      if (!current) return;
      var box = scroller.getBoundingClientRect();
      var item = current.getBoundingClientRect();
      if (item.top >= box.top && item.bottom <= box.bottom) return;
      scroller.scrollTop += item.top - box.top - (box.height - item.height) / 2;
    }

    function settle(current, next) {
      if (current && current !== next) {
        current.classList.remove('is-active', 'is-to-left', 'is-to-right', 'is-from-left', 'is-from-right');
        clearInline(current);
        current.hidden = true;
        current.setAttribute('inert', '');
      }
      next.classList.remove('is-from-left', 'is-from-right');
      clearInline(next);
      next.classList.add('is-active');
      next.hidden = false;
      next.removeAttribute('inert');
      busy = false;
      paintRails();
    }

    function show(id, backwards, focusTarget) {
      var next = panelById(id);
      var current = activePanel();
      if (!next || next === current) {
        busy = false;
        if (focusTarget) {
          focusEl(focusTarget);
          retrap(focusTarget);
        }
        return;
      }
      next.hidden = false;
      next.removeAttribute('inert');
      fitSheet(next);
      if (backwards) {
        restoreScroll(next);
      } else {
        scrollMemo[id] = 0;
        restoreScroll(next);
        revealCurrent(next);
      }
      if (reduce.matches) {
        settle(current, next);
        focusEl(focusTarget);
        retrap(focusTarget);
        return;
      }
      var mover = next;
      if (backwards) {
        /* The screen underneath stays put. Only the open submenu slides off to the right. */
        next.classList.add('is-active');
        next.style.transition = 'none';
        void next.offsetWidth;
        next.style.transition = '';
        if (current) current.classList.add('is-to-right');
        mover = current || next;
      } else {
        next.classList.add('is-from-right');
        void next.offsetWidth;
        next.classList.add('is-active');
        next.classList.remove('is-from-left', 'is-from-right');
        if (current) current.classList.add('is-to-left');
      }
      paintRails();
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        settle(current, next);
        focusEl(focusTarget);
        retrap(focusTarget);
      }
      var timer = window.setTimeout(finish, SLIDE_MS);
      mover.addEventListener('transitionend', function onEnd(event) {
        if (event.target !== mover || event.propertyName !== 'transform') return;
        mover.removeEventListener('transitionend', onEnd);
        window.clearTimeout(timer);
        finish();
      });
    }

    function openPanel(id, opener) {
      if (busy) return;
      if (!panelById(id)) return;
      busy = true;
      stack.push({ id: id, opener: opener });
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var next = panelById(id);
      show(id, false, next.querySelector('[data-ri-mnav-back]'));
    }

    function goBack() {
      if (busy || stack.length < 2) return;
      var frame = stack.pop();
      var prev = stack[stack.length - 1];
      if (frame.opener) frame.opener.setAttribute('aria-expanded', 'false');
      busy = true;
      show(prev.id, true, frame.opener);
    }

    function reset() {
      busy = false;
      drag = null;
      stack = [{ id: 'home', opener: null }];
      scrollMemo = {};
      nav.querySelectorAll('.ri-mnav__panel').forEach(function (node) {
        var home = panelId(node) === 'home';
        node.classList.remove('is-active', 'is-to-left', 'is-to-right', 'is-from-left', 'is-from-right');
        clearInline(node);
        if (home) {
          node.hidden = false;
          node.removeAttribute('inert');
          node.classList.add('is-active');
        } else {
          node.hidden = true;
          node.setAttribute('inert', '');
        }
      });
      nav.querySelectorAll('[data-ri-mnav-open][aria-expanded="true"]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    }

    /* A company row lights up when the page you are on lives anywhere under it (Systems and Accessories pages are
       not in the Shopify menu, so Liquid's child_active misses them). */
    function markCurrentOpeners() {
      for (var pass = 0; pass < 3; pass += 1) {
        nav.querySelectorAll('.ri-mnav__panel').forEach(function (panel) {
          var id = panelId(panel);
          if (id === 'home' || !panel.querySelector('.is-current')) return;
          nav.querySelectorAll('[data-ri-mnav-open="' + id + '"]').forEach(function (opener) {
            opener.classList.add('is-current');
          });
        });
      }
    }

    /* The main screen's rows share the room above the pinned foot evenly, so every department fits top to bottom
       with no scrolling and no row cut off under Sell Your Games (owner, 2026-10-23). The last row's bottom border
       sits just past the room, so the foot's own top line is the only line there. On a screen too short for 44px
       rows they stay 44px and the list scrolls. */
    function fitHomeRows() {
      var home = panelById('home');
      var scroller = scrollerOf(home);
      if (!scroller || home.hidden) {
        paintRails();
        return;
      }
      scroller.style.removeProperty('--ri-mnav-home-row');
      var room = scroller.clientHeight;
      var rows = scroller.querySelectorAll('.ri-mnav__home-list > .ri-mnav__row');
      if (room && rows.length) {
        var rowsHeight = 0;
        Array.prototype.forEach.call(rows, function (row) {
          rowsHeight += row.getBoundingClientRect().height;
        });
        /* The list's own height without the flex stretch (scrollHeight never reads below the box). */
        var prevFlex = scroller.style.flex;
        var prevHeight = scroller.style.height;
        scroller.style.flex = 'none';
        scroller.style.height = 'auto';
        var natural = scroller.offsetHeight;
        scroller.style.flex = prevFlex;
        scroller.style.height = prevHeight;
        var fixed = Math.max(0, natural - rowsHeight);
        var each = (room + 2 - fixed) / rows.length;
        if (each >= 44) scroller.style.setProperty('--ri-mnav-home-row', each + 'px');
      }
      paintRails();
    }

    /* The sheet always runs to the bottom of the screen (owner, 2026-10-23, after a fit-to-rows try); only the main
       screen's rows are sized. */
    function fitSheet() {
      fitHomeRows();
    }

    /* Panel photos are lazy while hidden. Fetch them once the sheet is open so a screen paints with its photos. */
    function warmPhotos(root) {
      (root || nav).querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    }

    /* ---- Tap feedback and prefetch ---- */

    function sameDocument(url) {
      return url.pathname === window.location.pathname && url.search === window.location.search;
    }

    function prefetch(href) {
      var url;
      try {
        url = new URL(href, window.location.href);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin || sameDocument(url)) return;
      url.hash = '';
      if (prefetched[url.href]) return;
      prefetched[url.href] = true;
      if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
        var rules = document.createElement('script');
        rules.type = 'speculationrules';
        rules.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [url.href] }] });
        document.head.appendChild(rules);
        return;
      }
      var hint = document.createElement('link');
      hint.rel = 'prefetch';
      hint.as = 'document';
      hint.href = url.href;
      document.head.appendChild(hint);
    }

    function clearLoading() {
      nav.querySelectorAll('.is-loading').forEach(function (node) {
        node.classList.remove('is-loading');
      });
    }

    var leavingAt = 0;

    nav.addEventListener(
      'pointerdown',
      function (event) {
        var opener = event.target.closest('[data-ri-mnav-open]');
        if (opener && nav.contains(opener)) warmPhotos(panelById(opener.getAttribute('data-ri-mnav-open')));
        var link = event.target.closest('a[href]');
        if (link && nav.contains(link)) {
          prefetch(link.href);
          leavingAt = Date.now();
        }
      },
      { passive: true }
    );

    /* Tapping a menu link (owner, 2026-10-23: the screen shifted down before the next page). An iPhone does not
       focus a tapped link, so focus left the menu and the drawer's focus-out check closed it while the next page
       loaded: the sheet wiped up and the page lock let go under the finger. While a menu link is opening, that
       focus-out is stopped before it reaches the drawer; the menu stays as it is until the page goes. */
    var drawerEl = details && details.closest('header-drawer');
    if (drawerEl) {
      drawerEl.addEventListener(
        'focusout',
        function (event) {
          if (leavingAt && Date.now() - leavingAt < 2000) event.stopPropagation();
        },
        true
      );
    }

    /* Leaving with the menu open. It used to shut as the page went (pageswap, pagehide) so Back would not show it
       (owner, 2026-10-23: Back from Sell Your Games showed the menu for a moment). But the old page can still be
       drawn between leaving and the next page's first paint, so a tap on a menu link showed the page under the
       menu while the next one loaded (owner, 2026-10-24, Pokemon Singles). Now the menu stays as it is while the
       next page loads, and a page brought back by Back shuts it before its first frame (pagereveal), or on
       pageshow where pagereveal is missing, with no closing slide. */
    var shutForLeave = function () {
      leavingAt = 0;
      if (!details || !details.open) return;
      /* No closing slide: it would still be under way when the picture is taken. */
      document.documentElement.classList.add('ri-mnav-leaving');
      var summary = details.querySelector('summary');
      if (drawerEl && typeof drawerEl.closeMenuDrawer === 'function' && summary) {
        drawerEl.closeMenuDrawer(new Event('pagehide'), summary);
      }
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      clearLoading();
      reset();
    };
    var shutOnReturn = function () {
      if (!details || !details.open) return;
      shutForLeave();
      /* The no-slide class goes after two frames, once the shut menu has been drawn, so the next open slides
         (a timer too, in case a background tab gets no frames). */
      var settled = function () {
        document.documentElement.classList.remove('ri-mnav-leaving');
      };
      requestAnimationFrame(function () {
        requestAnimationFrame(settled);
      });
      window.setTimeout(settled, 200);
    };
    window.addEventListener('pagereveal', shutOnReturn);

    nav.addEventListener(
      'scroll',
      function (event) {
        var scroller = event.target;
        if (!scroller.classList || !scroller.classList.contains('ri-mnav__scroll')) return;
        if (details && !details.classList.contains('menu-opening')) return;
        var panel = scroller.closest('.ri-mnav__panel');
        if (panel) scrollMemo[panelId(panel)] = scroller.scrollTop;
        paintRail(scroller);
      },
      true
    );

    nav.addEventListener('click', function (event) {
      var back = event.target.closest('[data-ri-mnav-back]');
      if (back && nav.contains(back)) {
        event.preventDefault();
        goBack();
        return;
      }

      var opener = event.target.closest('[data-ri-mnav-open]');
      if (opener && nav.contains(opener)) {
        event.preventDefault();
        openPanel(opener.getAttribute('data-ri-mnav-open'), opener);
        return;
      }

      var link = event.target.closest('a[href]');
      if (!link || !nav.contains(link)) return;
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      if (link.target && link.target !== '_self') return;
      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }
      if (sameDocument(url)) return;
      clearLoading();
      link.classList.add('is-loading');
    });

    /* ---- Swipe right to go back ---- */

    var drag = null;
    var DECIDE_PX = 10;

    function beginDrag() {
      drag.prev.hidden = false;
      drag.prev.removeAttribute('inert');
      restoreScroll(drag.prev);
      drag.prev.style.visibility = 'visible';
      drag.prev.style.transform = 'translateX(0)';
      drag.cur.classList.add('is-dragging');
      drag.prev.classList.add('is-dragging');
    }

    function applyDrag(dx) {
      drag.cur.style.transform = 'translateX(' + dx + 'px)';
      drag.prev.style.transform = 'translateX(0)';
    }

    function endDrag(commit) {
      var cur = drag.cur;
      var prev = drag.prev;
      drag = null;
      busy = true;
      var animate = !reduce.matches;
      cur.classList.remove('is-dragging');
      prev.classList.remove('is-dragging');
      if (animate) void cur.offsetWidth;

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        if (commit) {
          var frame = stack.pop();
          if (frame.opener) frame.opener.setAttribute('aria-expanded', 'false');
          settle(cur, prev);
          fitSheet(prev);
          focusEl(frame.opener);
          retrap(frame.opener);
        } else {
          clearInline(cur);
          clearInline(prev);
          prev.hidden = true;
          prev.setAttribute('inert', '');
          busy = false;
        }
      }

      if (commit) {
        cur.style.transform = 'translateX(100%)';
        prev.style.transform = 'translateX(0)';
      } else {
        cur.style.transform = 'translateX(0)';
        prev.style.transform = 'translateX(0)';
      }
      if (!animate) {
        finish();
        return;
      }
      var timer = window.setTimeout(finish, SLIDE_MS);
      cur.addEventListener('transitionend', function onEnd(event) {
        if (event.target !== cur || event.propertyName !== 'transform') return;
        cur.removeEventListener('transitionend', onEnd);
        window.clearTimeout(timer);
        finish();
      });
    }

    if (stage) {
      stage.addEventListener(
        'touchstart',
        function (event) {
          if (busy || stack.length < 2 || event.touches.length !== 1) {
            drag = null;
            return;
          }
          var touch = event.touches[0];
          var cur = activePanel();
          var prev = panelById(stack[stack.length - 2].id);
          if (!cur || !prev) return;
          drag = {
            x0: touch.clientX,
            y0: touch.clientY,
            dx: 0,
            lastX: touch.clientX,
            lastT: event.timeStamp,
            speed: 0,
            mode: null,
            cur: cur,
            prev: prev,
            w: stage.clientWidth || window.innerWidth,
          };
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchmove',
        function (event) {
          if (!drag) return;
          var touch = event.touches[0];
          var dx = touch.clientX - drag.x0;
          var dy = touch.clientY - drag.y0;
          if (!drag.mode) {
            if (Math.abs(dx) < DECIDE_PX && Math.abs(dy) < DECIDE_PX) return;
            if (dx > 0 && Math.abs(dx) > Math.abs(dy) * 1.2) {
              drag.mode = 'x';
              beginDrag();
            } else {
              drag = null;
              return;
            }
          }
          event.preventDefault();
          var dt = event.timeStamp - drag.lastT;
          if (dt > 0) drag.speed = (touch.clientX - drag.lastX) / dt;
          drag.lastX = touch.clientX;
          drag.lastT = event.timeStamp;
          drag.dx = Math.max(0, dx);
          applyDrag(drag.dx);
        },
        { passive: false }
      );

      var release = function (event) {
        if (!drag) return;
        if (drag.mode !== 'x') {
          drag = null;
          return;
        }
        var flick = drag.speed > 0.5 && event.timeStamp - drag.lastT < 100;
        endDrag(drag.dx > drag.w * 0.3 || flick);
      };
      stage.addEventListener('touchend', release);
      stage.addEventListener('touchcancel', function () {
        if (drag && drag.mode === 'x') endDrag(false);
        else drag = null;
      });
    }

    /* ---- Keyboard and lifecycle ---- */

    document.addEventListener(
      'keyup',
      function (event) {
        if (event.key !== 'Escape' && event.code !== 'Escape') return;
        if (!details || !details.open) return;
        if (stack.length > 1) {
          event.stopPropagation();
          goBack();
        }
      },
      true
    );

    if (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        fitSheet();
        var panel = activePanel();
        if (panel) window.requestAnimationFrame(function () {
          fitSheet(panel);
          restoreScroll(panel);
          paintRails();
        });
        window.setTimeout(warmPhotos, 250);
      });
    }

    var fitTimer = 0;
    window.addEventListener('resize', function () {
      window.clearTimeout(fitTimer);
      fitTimer = window.setTimeout(function () {
        if (details && details.open) fitSheet();
        else fitHomeRows();
        paintRails();
      }, 120);
    });

    window.addEventListener('pageshow', function (event) {
      document.documentElement.classList.remove('ri-mnav-leaving');
      if (!event.persisted) return;
      shutOnReturn();
      clearLoading();
      reset();
    });

    markCurrentOpeners();
    ensureRails();
  }

  if (document.querySelector('.ri-mnav')) boot();
  else document.addEventListener('ri:header-menus', boot);
})();
